import {SET_PENDING_TRANSACTIONS} from 'constants/action-types.js';

let initialState = {
    pendingTransactions: [],
};
    
const transactionsReducer = (state = initialState, action) => {
    let newState;
    switch (action.type) {
    case SET_PENDING_TRANSACTIONS:
        return {
            ... state,
            pendingTransactions: action.payload
        };
    default:
        return state;
    }
};

export default transactionsReducer;
